import { ITaskState, ITimelineItem } from "./types";
import { IRootState } from "../types";
import { ActionTree, ActionContext } from "vuex";
import { TASK } from ".";
import { UI } from "@/store/ui";
import api from "@/api/signup/api";
import { ERROR_MESSAGES } from "@/constants/errors";

export namespace TASK_ACTIONS {
  export const ASSIGN_TASK = "assignTask";
  export const UNASSIGN_TASK = "unAssignTask";
  export const LOAD_APPLICATION_TIMELINE = "loadApplicationTimeline";
}

export const actions: ActionTree<ITaskState, IRootState> = {
  async [TASK_ACTIONS.ASSIGN_TASK](
    context: ActionContext<ITaskState, IRootState>,
    task: ITimelineItem
  ): Promise<void> {
    if (!task || !task.taskId) {
      return;
    }

    try {
      const response = await api.assignTask(task.taskId);
      if (response.status === 204 && context.rootState.auth.user) {
        // Update the assignedTo value and replace the task
        const updatedTask = {
          ...task,
          assignedTo: context.rootState.auth.user.userName
        };
        context.commit(TASK.MUTATIONS.UPDATE_TASK, updatedTask);
      }
    } catch (error: any) {
      context.dispatch(
        UI.NS(UI.ACTIONS.ADD_TOAST),
        {
          id: "failed-assign-task",
          text: ERROR_MESSAGES.ASSIGN_TASK_ERROR,
          error
        },
        { root: true }
      );
    }
  },
  async [TASK_ACTIONS.UNASSIGN_TASK](
    context: ActionContext<ITaskState, IRootState>,
    task: ITimelineItem
  ): Promise<void> {
    if (!task || !task.taskId) {
      return;
    }

    try {
      const response = await api.unassignTask(task.taskId);
      if (response.status === 204 && context.rootState.auth.user) {
        // Update the assignedTo value and replace the task
        const updatedTask = { ...task, assignedTo: "" };

        context.commit(TASK.MUTATIONS.UPDATE_TASK, updatedTask);
      }
    } catch (error: any) {
      context.dispatch(
        UI.NS(UI.ACTIONS.ADD_TOAST),
        {
          id: "failed-unassign-task",
          text: ERROR_MESSAGES.UNASSIGN_TASK_ERROR,
          error
        },
        { root: true }
      );
    }
  },
  async [TASK_ACTIONS.LOAD_APPLICATION_TIMELINE](
    { commit, dispatch },
    id
  ): Promise<void> {
    try {
      const response = await api.getApplicationTimeline(id);
      commit(TASK.MUTATIONS.SET_APPLICATION_TIMELINE, response.data);
    } catch (error: any) {
      dispatch(
        UI.NS(UI.ACTIONS.ADD_TOAST),
        {
          id: "failed-load-application-timeline",
          text: ERROR_MESSAGES.LOAD_APPLICATION_TIMELINE_ERROR,
          error
        },
        { root: true }
      );
    }
  },
};
